<ng-template #loading>
    <div class="loading">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>
<app-dialog-sidebar>
    <section class="wrapper">
        <div class="svg-wrapper">
            <app-svg-icon iconName="logo_club" [options]="{ pathInheritFill: false }"></app-svg-icon>
        </div>
        <h2>{{ 'login.title' | translateSafe }}</h2>
        <p class="subtitle">{{ 'login.subtitle' | translateSafe }}</p>
        <form class="form" [formGroup]="form" (submit)="onSubmit()" appHandleInvalidOnSubmit>
            <app-input-email
                [control]="form.controls['username']"
                [marginBottom]="data.userVerified ? 'small' : 'default'"
            ></app-input-email>

            <p
                class="display-7"
                *ngIf="data.userVerified && data.userVerified !== 'CouldnotBeVerified'"
                [innerHTML]="'login.accountActivated' | translateSafe"
            ></p>

            <div *ngIf="!loggingIn(); else loading" class="controls">
                <!-- Large phone, tablet and desktop button -->
                <div class="large-screen-button">
                    <ng-container [ngTemplateOutlet]="loginButtons"
                                  [ngTemplateOutletContext]="{ fullWidth: false }"></ng-container>
                </div>
                <!-- Medium and small phone button -->
                <div class="small-screen-button">
                    <ng-container [ngTemplateOutlet]="loginButtons"
                                  [ngTemplateOutletContext]="{ fullWidth: true }"></ng-container>
                </div>

                <div class="buttons-wrapper">
                    <div class="or-text-separator display-caption">{{ 'login.orText' | translateSafe }}</div>

                    <button type="button" class="vipps-login-button" (click)="loginWithVipps()">
                        <app-svg-icon iconName="vipps_log_in"></app-svg-icon>
                    </button>
                </div>
            </div>
        </form>

    </section>
</app-dialog-sidebar>

<ng-template #loginButtons let-fullWidth="fullWidth">

    <app-icon-button [fullWidth]="fullWidth" iconPosition="after" variant="primary" iconName="arrow_right"
                     type="submit">
        {{ 'login.next' | translateSafe }}
    </app-icon-button>

</ng-template>
